import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { FormattedMessage } from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import checkInIcon from 'static/icons/check-in.svg';
import checkOutIcon from 'static/icons/check-out.svg';
import ImageFrame from 'components/gallery/imageGalleryPreview/components/ImageFrameComponent';
import RoomOccupancy from 'components/inputs/dataPresentation/roomOccupancy/RoomOccupancyComponent';
import Summary from 'routes/checkoutPage/components/travelSummary/components/summarySection/SummarySection';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

function HotelSummaryComponent({
  summaryKey,
  title,
  image,
  checkInDateTime,
  checkOutDateTime,
  checkInTime,
  checkOutTime,
  rooms,
}) {
  const fromDate = moment(checkInDateTime).format('DD MMM YYYY');
  const toDate = moment(checkOutDateTime).format('DD MMM YYYY');

  return (
    <Summary summaryKey={summaryKey} title={title}>
      <Root>
        {image && <ImageFrame image={image} />}
        <DatesWrap>
          <DateWrap>
            <DateIcon src={checkInIcon} />
            <DateTimeWrap>
              <Date>{fromDate}</Date>
              <Time>{checkInTime}</Time>
            </DateTimeWrap>
          </DateWrap>
          <DateWrap>
            <DateIcon src={checkOutIcon} />
            <DateTimeWrap>
              <Date>{toDate}</Date>
              <Time>{checkOutTime}</Time>
            </DateTimeWrap>
          </DateWrap>
        </DatesWrap>
        <Rooms>
          <RoomIcon>
            <FontAwesomeIcon icon='bed' />
          </RoomIcon>
          <RoomsWrap>
            {rooms &&
              rooms.map(({ productToken, roomName, boardName, numberOfAdults, numberOfChildren }, index) => (
                <RoomWrap key={productToken}>
                  <RoomNumber>
                    <FormattedMessage
                      id={'roomNumber.formatted.selectordinal'}
                      description={`{roomNumber, selectordinal, one {First} two {Second} few {#rd} other {#th}} Room`}
                      defaultMessage={`{roomNumber, selectordinal, one {First} two {Second} few {#rd} other {#th}} Room`}
                      values={{ roomNumber: index + 1 }}
                    />
                  </RoomNumber>
                  &nbsp;&nbsp;-&nbsp;
                  <RoomOccupancy numberOfAdults={numberOfAdults} numberOfChildren={numberOfChildren} />
                  {`, ${roomName}, ${boardName}`}
                </RoomWrap>
              ))}
          </RoomsWrap>
        </Rooms>
      </Root>
    </Summary>
  );
}

export default HotelSummaryComponent;

const Root = styled.div`
  > * {
    margin-bottom: 20px;
  }
`;

const DatesWrap = styled.div`
  ${flexbox({
    justifyContent: 'space-between',
  })}
`;

const DateWrap = styled.div`
  ${flexbox({
    alignItems: 'flex-start',
  })}
`;

const DateIcon = styled.img`
  width: 14px;
  margin-right: 7px;
`;

const DateTimeWrap = styled.div`
  font-size: 1.6em;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.default};

  ${mediaQueries.fromAndAbove.desktop`
    font-size: 1.3em;
  `}
`;

const Date = styled.div`
  margin-bottom: 5px;
  font-weight: 700;
`;

const Time = styled.div``;

const Rooms = styled.div`
  ${flexbox()}
  color: ${({ theme }) => theme.colors.text.default};
`;

const RoomIcon = styled.div`
  margin-right: 7px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.light};
`;

const RoomsWrap = styled.div``;

const RoomWrap = styled.div`
  font-size: 1.4em;
  font-weight: 500;
  line-height: 1.3;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  ${mediaQueries.fromAndAbove.desktop`
    font-size: 1.2em;
  `}
`;

const RoomNumber = styled.span`
  font-weight: 700;
`;
